export default function selectTrelloBoardsById(state) {
  return state.integrations.thirdPartyData.trello.boards
}
